import React from 'react';
import headerActions from '../../../../actions/header';

export default class HeaderLanguage extends React.Component {
  static propTypes = {
    isMobile:          React.PropTypes.bool,
    link:              React.PropTypes.string,
    shortDisplayName:   React.PropTypes.string,
    fullDisplayName:   React.PropTypes.string
  };

  render () {
    let containerClass;

    if (this.props.isMobile) {
      containerClass = 'header__language--mobile__item';
    }
    else {
      containerClass = 'header__language__item';
    }

    return (
      <li className={containerClass}>
        <a
          href={this.props.link}
          onClick={(e) => { e.preventDefault(); headerActions.toggleSlidingPanel(); }}
          data-component="languageItemLink"
          aria-label={this.props.fullDisplayName}>{this.props.shortDisplayName}</a>
      </li>
    );
  }
}



// WEBPACK FOOTER //
// ./frontend/react/components/header/language/language/index.js